module.exports = __webpack_public_path__ + "img/coins-hand.0282f306.svg";